import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../Common/Alert";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import ReactDataTable from "../../Common/ReactDataTable";

import useAlertFromLocation from "../../../hooks/useAlertFromLocation";

const List = () => {
  const navigate = useNavigate();
  const [receiveData, setReceiveData] = useState([]);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(false);

  const alert = useAlertFromLocation();

  const fetchData = async () => {
    setLoading(true);
    try {
      const [res1, res2] = await Promise.all([Http.get("/crm"), Http.get("/staff-type-check")]);
      setReceiveData(res1.data);
      setRole(res2.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Hand the ticket over to the warehouse. Only admin and depot may do this.
  const transferWarehouse = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This Ticket will be transferred to the Warehouse.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, transfer it!",
    }).then((result) => {
      if (result.isConfirmed) {
        Http.post("/crm-transfer-warehouse/" + id)
          .then((res) => {
            Swal.fire("Transferred!", res.data.message, "success");
            fetchData();
          })
          .catch((e) => {
            Swal.fire("Failed!", e.response ? e.response.data.message : "Please try again.", "error");
          });
      }
    });
  };

  // The legacy screen showed "Factory" wherever the Central Warehouse solved a ticket.
  const solverName = (item) => {
    if (!item.solver) return "";
    return item.solver.name === "Central Warehouse" ? "Factory" : item.solver.name;
  };

  const statusColumn = (item) => {
    if (item.solver_id) {
      return (
        <span className="btn btn-success btn-sm">
          <i className="fa fa-check"></i>
        </span>
      );
    }

    // Already with the warehouse: nobody but the warehouse side acts on it.
    if (item.assign_to === "Warehouse" && role !== "supply_chain" && role !== "admin") {
      return (
        <span className="btn btn-warning btn-sm">
          <i className="fa fa-exchange"></i> Transferred
        </span>
      );
    }

    // supply_chain raises tickets but can only close the ones that reached the warehouse.
    if (role === "supply_chain" && item.assign_to !== "Warehouse") {
      return (
        <span className="btn btn-secondary btn-sm">
          <i className="fa fa-exchange"></i> Depot
        </span>
      );
    }

    return (
      <div className="text-nowrap">
        {item.assign_to === "Warehouse" && (
          <span className="btn btn-warning btn-sm me-1">
            <i className="fa fa-exchange"></i> Transferred
          </span>
        )}
        {item.assign_to !== "Warehouse" && (role === "admin" || role === "depot") && (
          <button className="btn btn-info btn-sm me-1" onClick={() => transferWarehouse(item.id)} title="Transfer to Warehouse">
            Transfer
          </button>
        )}
        <button className="btn btn-primary btn-sm" onClick={() => navigate("/crm-solve/" + item.id)} title="Solve">
          Solve
        </button>
      </div>
    );
  };

  const cols = [
    { field: "date", header: "Date" },
    { field: "time", header: "Time" },
    { field: "ticket_no", header: "Ticket No" },
    { field: "ticket_for", header: "Ticket for" },
    { field: "complain_type", header: "Complain type" },
    { field: (item) => solverName(item), header: "Solved By" },
    // Not "Status": ReactDataTable swaps that header's body for its active/inactive tag.
    { field: (item) => statusColumn(item), header: "Ticket Status" },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">All Tickets</h5>
            {(role === "admin" || role === "supply_chain") && (
              <Link to="/create-crm" className="btn btn-primary">
                <i className="fa fa-plus-square mg-r-6"></i> New Ticket
              </Link>
            )}
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <ReactDataTable cols={cols} receiveData={receiveData} isLoading={loading} actionTemplate={actionTemplate} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const actionTemplate = (rowData) => {
  return (
    <div className="text-xs text-nowrap">
      <Link to={{ pathname: "/crm-detail/" + rowData.id }} className="btn btn-info btn-sm" title="View">
        <i className="fa fa-list" aria-hidden="true"></i>
      </Link>
    </div>
  );
};

export default List;
